const getEventScheduleState = (event) => {
  const getSchedule = (code) =>
    event?.scheduledActions?.find(
      action =>
        action?.type?.code === code &&
        action?.status?.code === "SCHEDULED"
    ) ?? null

  return {
    openStaffSchedule: getSchedule("OPEN_STAFF"),
    openParentsSchedule: getSchedule("OPEN_PARENTS"),
    disabledParentBookingsSchedule: getSchedule("DISABLE_PARENT_BOOKINGS"),
  }
}

export default getEventScheduleState